import React from 'react';
import PropTypes from 'prop-types';
import Chip from '../../Chip';
import { Container } from '../../Layout';
import { StyledContainer, StyledThumbnail, StyledDetails } from './styles';

const CardContainer = props => {
  return (
    <StyledContainer
      to={props.dest}
      theme={{
        type: props.type,
        color_light: props.theme_light,
        color_dark: props.theme_dark,
        image: props.thumbnail && props.thumbnail.url,
      }}
    >
      <StyledThumbnail>
        {props.topLeft && (
          <div className="screen screenTopLeft">
            <Chip label={props.topLeft} />
          </div>
        )}
        {props.topRight && (
          <div className="screen screenTopRight">
            <Chip label={props.topRight} />
          </div>
        )}
        {props.bottomLeft && (
          <div className="screen screenBottomLeft">
            <Chip label={props.bottomLeft} />
          </div>
        )}
        {props.bottomRight && (
          <div className="screen screenBottomRight">
            <Chip label={props.bottomRight} />
          </div>
        )}
        {props.thumbnail && props.thumbnail.url && (
          <img
            className="thumbnail"
            src={props.thumbnail.url}
            alt={props.thumbnail.alt || ''}
            width={props.thumbnail.width}
            height={props.thumbnail.height}
            loading="lazy"
          />
        )}
      </StyledThumbnail>

      <StyledDetails>
        {props.metaText && (
          <div className="detailsMeta">
            <h6 style={{ color: `var(--color-primary-light)` }}>
              {props.metaText}
            </h6>
          </div>
        )}
        <Container restrict>
          <h5 className="title">{props.title}</h5>
          {props.subtitle && <h6 className="subtitle">{props.subtitle}</h6>}
          {props.description && (
            <p className="description">{props.description}</p>
          )}

          {props.buttonText && (
            <p
              style={{
                marginTop: 'var(--size-space-small)',
              }}
            >
              <span className="button">{props.buttonText}</span>
            </p>
          )}
        </Container>
      </StyledDetails>
    </StyledContainer>
  );
};

CardContainer.propTypes = {
  type: PropTypes.oneOf(['inline', 'flexible']),
  theme_light: PropTypes.string,
  theme_dark: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  dest: PropTypes.string.isRequired,
  onClick: PropTypes.func,

  // Thumbnail
  thumbnail: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  // Thumb Metadata
  topLeft: PropTypes.string,
  topRight: PropTypes.string,
  bottomRight: PropTypes.string,
  bottomLeft: PropTypes.string,

  // Details
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
};
CardContainer.defaultProps = {
  type: 'inline',
  align: 'left',
};

export default CardContainer;
